import React, { PropsWithChildren, useEffect, useMemo, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { getStripeElementStyles } from './styles';
import type { Stripe } from '@stripe/stripe-js';
import { ITheme } from 'models';
import { DARK_THEME } from 'services/themes/constants';

interface IProps extends PropsWithChildren {
  apiKey: string;
  fonts: {
    baseUrl: string;
    name: string;
  }[];
  isActive: boolean;
  theme: ITheme;
}

const StripeElements = ({ isActive, children, theme, apiKey, fonts }: IProps) => {
  const [stripePromise, setStripePromise] = useState<Promise<Stripe | null> | null>(null);

  const stripeElementStyles = useMemo(() => getStripeElementStyles(theme || DARK_THEME), [theme]);

  useEffect(() => {
    if (isActive && !stripePromise) {
      import('@stripe/stripe-js').then(({ loadStripe }) => {
        const stripeInitiator = loadStripe(apiKey);
        setStripePromise(stripeInitiator);
      });
    }
  }, [isActive, apiKey, stripePromise]);

  if (!stripePromise || !theme) {
    return <>{children}</>;
  }

  return (
    <Elements
      key={`${theme._id}-${theme.typography.body}`}
      stripe={stripePromise}
      options={{
        appearance: stripeElementStyles,
        fonts: fonts.map(font => ({
          family: font.name,
          src: `url(${font.baseUrl}.ttf)`,
          weight: '600',
        })),
      }}
    >
      {children}
    </Elements>
  );
};

export default StripeElements;
